import { gql } from 'graphql-tag';

export default (stringifiedKeys: string) => gql`
  query GetTranslationsByKey(
    $retailerMoniker: String!
    $localeLanguage: Language!
    $localeCountry: Country
    $versionName: String
    $type: String
    $category: String
    $status: String
    $cache: Boolean
  ) {
    retailerTranslations(
      retailerMoniker: $retailerMoniker
      product: "narvarjs_translations"
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
      versionName: $versionName
      type: $type
      category: $category
      status: $status
      cache: $cache
    ) {
      ${stringifiedKeys}
    }
  }
`;
